import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/realative-family.png";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/soco-grandparents-and-family.png";
import { FaPlus, FaTimes, FaClock, FaUserFriends, FaHeartbeat, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const AustralianRelativesVisa = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "My mother's aged dependent relative visa was approved in 28 months thanks to Immiget's thorough preparation.",
      name: "Michael L.",
      location: "Sydney, Australia",
      visaType: "Aged Dependent Relative Visa"
    },
    {
      content: "After two failed attempts, Immiget finally got my brother's remaining relative visa approved.",
      name: "Sarah T.",
      location: "Melbourne, Australia",
      visaType: "Remaining Relative Visa"
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Australian Relative Visas (Subclass 115, 116, 117, 836) – Immiget Global</title>
        <meta
          name="description"
          content="Sponsor your relatives to live permanently in Australia. Expert guidance for Carer, Remaining Relative, and Aged Dependent Relative visas. 92% success rate with Immiget Global."
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Australian Relative Visas (Subclass 115, 116, 117, 836)
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Individual & Families
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Australian Relative Visas
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            Australian Relative Visas – Family Reunion Pathways
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            Want to sponsor your relatives to live permanently in Australia? The Carer, Remaining Relative, and Aged Dependent Relative visas allow Australian citizens and permanent residents to reunite with eligible family members. At Immiget Global, we specialise in complex family migration cases with a 92% success rate.
          </p>
          
          {/* Success Rate Highlight */}
          <div className="mt-6 bg-blue/10 p-4 rounded-lg max-xl:text-center">
            <div className="flex items-center gap-2 max-xl:justify-center">
              <FaCheckCircle className="text-blue text-xl" />
              <span className="text-blue text-xl font-semibold hellix-font">92% Success Rate</span>
            </div>
            <p className="text-blue text-sm hellix-font mt-1">
              Specializing in complex family migration cases
            </p>
          </div>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Australian Relative Visas" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligible Relative Visa Options */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Eligible Relative Visa Options
          </h1>
        </div>
        
        <div className="mt-6 space-y-8">
          {/* Carer Visa */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <FaHeartbeat className="text-blue text-2xl" />
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                1. Carer Visa (Subclass 116 & 836)
              </h3>
            </div>
            <p className="text-blue text-lg hellix-font mb-4">
              For relatives needed to care for an Australian citizen/PR holder with a medical condition
            </p>
            
            <h4 className="text-blue text-xl font-semibold hellix-font mb-3">Requirements:</h4>
            <div className="space-y-2 mb-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Sponsor has a medical condition requiring full-time care</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">No Australian resident can provide this care</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Carer must be willing and able to provide long-term assistance</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Meet health/character requirements</span>
              </div>
            </div>
            
            <div className="flex items-center gap-2 bg-blue/10 p-3 rounded">
              <FaClock className="text-blue" />
              <span className="text-blue font-semibold hellix-font">Processing Time: 18-36 months</span>
            </div>
          </div>

          {/* Remaining Relative Visa */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <FaUserFriends className="text-blue text-2xl" />
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                2. Remaining Relative Visa (Subclass 115 & 835)
              </h3>
            </div>
            <p className="text-blue text-lg hellix-font mb-4">
              For single applicants whose only near relatives live in Australia
            </p>
            
            <h4 className="text-blue text-xl font-semibold hellix-font mb-3">Requirements:</h4>
            <div className="space-y-2 mb-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">No parents/siblings outside Australia</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Sponsor must be settled Australian relative</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Applicant must be single (never married/no de facto)</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Meet balance-of-family test</span>
              </div>
            </div>
            
            <div className="flex items-center gap-2 bg-blue/10 p-3 rounded">
              <FaClock className="text-blue" />
              <span className="text-blue font-semibold hellix-font">Processing Time: 25-50 months</span>
            </div>
          </div>

          {/* Aged Dependent Relative Visa */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <img src={materialIcon} alt="family-icon" className="w-8 h-8" />
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                3. Aged Dependent Relative Visa (Subclass 114 & 838)
              </h3>
            </div>
            <p className="text-blue text-lg hellix-font mb-4">
              For elderly relatives financially dependent on their Australian family
            </p>
            
            <h4 className="text-blue text-xl font-semibold hellix-font mb-3">Requirements:</h4>
            <div className="space-y-2 mb-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Age 65+ (or 60+ for some countries)</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Financially dependent for ≥3 years</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Sponsor must provide full support</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Meet health requirements</span>
              </div>
            </div>
            
            <div className="flex items-center gap-2 bg-blue/10 p-3 rounded">
              <FaClock className="text-blue" />
              <span className="text-blue font-semibold hellix-font">Processing Time: 30-48 months</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global for Relative Visas?
          </h1>
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Specialist Knowledge</strong> of complex family migration
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Medical Evidence Experts</strong> for carer visa cases
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>High Approval Rate</strong> despite strict requirements
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Fast Processing</strong> through complete documentation
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>All Appeals Covered</strong> if application is refused
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Application Process Timeline */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Application Process Timeline
          </h1>
        </div>
        <div className="lg:ml-8 hellix-font mt-3">
          <div className="flex gap-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 1:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Eligibility Assessment</strong> (1-2 weeks)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 2:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Document Collection</strong> (4-8 weeks)
            </div>
          </div>
          <div className="lg:ml-14 ml-4 mt-2">
            <div className="flex gap-2">
              <img src={rightVector} alt="" className="min-w-[30px]" />
              <span className="text-blue text-lg hellix-font">Medical reports (for carer visas)</span>
            </div>
            <div className="flex gap-2">
              <img src={rightVector} alt="" className="min-w-[30px]" />
              <span className="text-blue text-lg hellix-font">Financial dependency proof</span>
            </div>
            <div className="flex gap-2">
              <img src={rightVector} alt="" className="min-w-[30px]" />
              <span className="text-blue text-lg hellix-font">Family relationship evidence</span>
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 3:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Lodgement & Acknowledgement</strong> (1-2 days)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 4:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Processing & Requests</strong> (12-48 months)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 5:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Visa Grant</strong> (1-2 months after approval)
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Common Reasons for Refusal & Solutions */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={helpIcon} alt="help" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Common Reasons for Refusal & Our Solutions
          </h1>
        </div>
        <p className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Learn about the most common reasons for relative visa refusals and how we help overcome these challenges.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          {/* Refusal Reason 1 */}
          <div className="bg-white shadow-lg rounded-lg border-l-4 border-red-500 overflow-hidden">
            <div className="bg-red-50 p-4 border-b border-red-100">
              <div className="flex items-center gap-3">
                <FaTimesCircle className="text-red-500 text-xl" />
                <h3 className="text-red-700 font-semibold hellix-font text-lg">
                  Insufficient Medical Evidence
                </h3>
              </div>
            </div>
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="bg-green-100 p-2 rounded-full flex-shrink-0">
                  <FaCheckCircle className="text-green-600" />
                </div>
                <div>
                  <h4 className="text-green-700 font-semibold hellix-font text-lg mb-2">Our Solution:</h4>
                  <p className="text-blue text-lg font-normal hellix-font">
                    We work with registered Australian doctors
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Refusal Reason 2 */}
          <div className="bg-white shadow-lg rounded-lg border-l-4 border-red-500 overflow-hidden">
            <div className="bg-red-50 p-4 border-b border-red-100">
              <div className="flex items-center gap-3">
                <FaTimesCircle className="text-red-500 text-xl" />
                <h3 className="text-red-700 font-semibold hellix-font text-lg">
                  Failed Balance-of-Family Test
                </h3>
              </div>
            </div>
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="bg-green-100 p-2 rounded-full flex-shrink-0">
                  <FaCheckCircle className="text-green-600" />
                </div>
                <div>
                  <h4 className="text-green-700 font-semibold hellix-font text-lg mb-2">Our Solution:</h4>
                  <p className="text-blue text-lg font-normal hellix-font">
                    Detailed relative mapping service
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Refusal Reason 3 */}
          <div className="bg-white shadow-lg rounded-lg border-l-4 border-red-500 overflow-hidden">
            <div className="bg-red-50 p-4 border-b border-red-100">
              <div className="flex items-center gap-3">
                <FaTimesCircle className="text-red-500 text-xl" />
                <h3 className="text-red-700 font-semibold hellix-font text-lg">
                  Financial Dependency Not Proven
                </h3>
              </div>
            </div>
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="bg-green-100 p-2 rounded-full flex-shrink-0">
                  <FaCheckCircle className="text-green-600" />
                </div>
                <div>
                  <h4 className="text-green-700 font-semibold hellix-font text-lg mb-2">Our Solution:</h4>
                  <p className="text-blue text-lg font-normal hellix-font">
                    Bank statement analysis & statutory declarations
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Refusal Reason 4 */}
          <div className="bg-white shadow-lg rounded-lg border-l-4 border-red-500 overflow-hidden">
            <div className="bg-red-50 p-4 border-b border-red-100">
              <div className="flex items-center gap-3">
                <FaTimesCircle className="text-red-500 text-xl" />
                <h3 className="text-red-700 font-semibold hellix-font text-lg">
                  Character Issues
                </h3>
              </div>
            </div>
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="bg-green-100 p-2 rounded-full flex-shrink-0">
                  <FaCheckCircle className="text-green-600" />
                </div>
                <div>
                  <h4 className="text-green-700 font-semibold hellix-font text-lg mb-2">Our Solution:</h4>
                  <p className="text-blue text-lg font-normal hellix-font">
                    Pre-lodgement police check review
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Urgent Call to Action */}
      <div className="bg-blue text-white py-8">
        <div className="container max-w-1440px mx-auto px-4 lg:px-14 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold hellix-font mb-4">
            Act Now - Quotas Apply!
          </h2>
          <p className="text-xl hellix-font mb-6">
            These visas have limited annual allocations. Book your consultation today to secure priority processing.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToContact}
              className="bg-white text-blue px-8 py-3 rounded-lg font-semibold hellix-font hover:bg-gray-100 transition-colors"
            >
              Free Eligibility Check
            </button>
            <button 
              onClick={scrollToContact}
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hellix-font hover:bg-white hover:text-blue transition-colors"
            >
              Immediate Case Review
            </button>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="lg:text-[28px] text-2xl text-center text-blue font-semibold hellix-font">
          Australian Relative Visas FAQs
        </h1>
        <p className="text-blue font-normal text-xl lg:text-[20px] text-center hellix-font">
          Get answers to common questions about Australian Relative Visas.
        </p>

        <div className="accordion-container mt-8">
          {/* FAQ 1 */}
          <div className="accordion">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(1)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                What is the difference between onshore and offshore relative visa subclasses?
              </h2>
              {activeIndex === 1 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  Subclasses 115, 116, and 117 are for applicants outside Australia, while 835, 836, and 838 are for those already in Australia on eligible visas.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 2 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(2)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                How long does the balance-of-family test take to assess?
              </h2>
              {activeIndex === 2 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  The balance-of-family test is assessed during the application process and requires detailed mapping of all family members worldwide, which typically takes 2-4 weeks to prepare properly.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 3 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(3)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                Can I sponsor multiple relatives under different visa categories?
              </h2>
              {activeIndex === 3 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 3 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  Yes, you can sponsor different relatives under different categories, but each application must meet specific criteria and there are annual limits on the number of visas granted.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 4 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(4)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                What medical evidence is required for carer visas?
              </h2>
              {activeIndex === 4 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 4 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  Comprehensive medical reports from registered Australian doctors, specialist assessments, care plans, and evidence that no other Australian resident can provide the required care.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 5 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(5)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                Are there income requirements for sponsors?
              </h2>
              {activeIndex === 5 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 5 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  Yes, sponsors must demonstrate adequate income to support the relative, provide an Assurance of Support, and meet ongoing financial obligations.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 6 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(6)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                What happens if my relative visa application is refused?
              </h2>
              {activeIndex === 6 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 6 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  You may be eligible to appeal to the Administrative Appeals Tribunal (AAT). Immiget Global provides comprehensive appeal support and representation.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="Recent Success Cases"
      />

      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default AustralianRelativesVisa;